<template>
  <div class="module-config">
    <component :is="setPhoneComponent()" ref="phoneIndex" @sort="setList" :organizationName="userInfo.organizationName"></component>
    <div class="right-content" v-show="tabList.length">
      <Tabs v-model="tab" @on-click="search">
        <TabPane :label="item.name" :name="item.moduleCode" v-for="(item,index) in tabList" :key="index"></TabPane>
      </Tabs>
      <div class="tools-box">
        <span class="info-text">提示：预览图内移动图标可改变顺序</span>
        <Button type="primary" style="width:80px" @click="$refs.appConfigForm.open({},curTabInfo)" v-show="$units.pointAction('systemSet_10_3')">添加工具</Button>
      </div>
      <div class="table-box" v-loading="loading">
        <Table :columns="columns" :data="tableData">
          <!-- 模块 -->
          <template slot-scope="{row}" slot="name">
            <div style="text-align: left;" @click="$units.pointAction('systemSet_10_3')&&$refs.appConfigForm.open(row,curTabInfo)">
              <img :src="row.img" style="width:30px">
              <span class="table-btn" style="text-decoration: underline;">{{row.name|subString(6)}}</span>
            </div>
          </template>
          <!-- 是否启用 -->
          <template slot-scope="{row}" slot="enable">
            <i-switch size="large" true-value="1" false-value="0" v-model="row.enable" @on-change="switchChange(row)" :disabled="!$units.pointAction('systemSet_10_3')">
              <span slot="open">启用</span>
              <span slot="close">禁用</span>
            </i-switch>
          </template>
          <!-- 操作 -->
          <template slot-scope="{row}" slot="action">
            <span class="table-btn" @click="remove(row)" v-show="$units.pointAction('systemSet_10_4')">删除</span>
          </template>
        </Table>
      </div>
    </div>
    

    <!-- 新增编辑模块 -->
    <app-config-form ref="appConfigForm" @success="search"></app-config-form>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>
<script>
import appConfigForm from "./components/appConfigForm";
import phoneIndex from "./components/phoneIndex";
import phonePersonal from "./components/phonePersonal";
import phoneMarketing from "./components/phoneMarketing";
import phoneCustomer from "./components/phoneCustomer";
import confirmModal from '@/components/commons/confirmModal'
export default {
  components:{
    phoneIndex,
    phonePersonal,
    phoneMarketing,
    phoneCustomer,
    appConfigForm,
    confirmModal,
  },
  data: () => ({
    tabList: [],
    tab: "",
    columns: [],

    total: 0,
    pageNo: 1,
    pageSize: 10,

    tableData: [], // 所有数据
    loading: false,
    dic:{},
    userInfo:{},
  }),
  mounted() {
    this.dic = JSON.parse(localStorage.dic)
    this.getTabList();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  computed: {
    curTabInfo() {
      //tab选中的信息
      if (this.tabList && this.tabList.length > 0) {
        const cur = this.tabList.find(item => item.moduleCode === this.tab);
        if (cur) {
          return cur;
        }
      }
    }
  },
  methods: {
    //获取tabList
    getTabList() {
      this.tabList = [];
      this.$http({
        type: "post",
        url: "/system/dic/read/dicList",
        data: {
          code: "DEFAULT_MERCHAT_MODULE_CODES",
        },
      }).then((res)=>{
        this.tabList = res.data.map(item=>{
          return {
            moduleCode:item.value,
            name:item.txt
          }
        })
        this.tab = this.tabList[0].moduleCode;
        this.search();
      })
    },

    remove(row) {
      this.$refs.confirmModal.open({
        title:"提示",
        content:"请确认是否将此工具删除？",
      }).then(() => {
        this.$http({
          url: "/buz/mcmMerchantModule/del",
          type: "DELETE",
          data: {
            id: row.id
          },
          apiPermissionCode:'systemSet_10_4'
        }).then(res => {
          this.search();
        });
      });
    },

    //搜索
    search() {
      this.pageNo = 1;
      this.getList();
    },
    // 列表
    getList() {
      this.loading = true;
      this.columns = this.getTableColumns();
      if(!this.$units.pointAction('systemSet_10_4')){
        this.columns.splice(this.columns.length-1, 1); 
      }
      this.tableData = [];
      this.$http({
        url: "/buz/mcmMerchantModule/queryModuleList",
        type: "PUT",
        data: {
          pageNo: this.pageNo,
          pageSize: 99,
          parentModuleCode: this.tab ? this.tab : this.tabList[0].moduleCode,
        },
        apiPermissionCode:'systemSet_10_0'
      })
        .then(res => {
          this.loading = false;
          res.data.forEach(item=>{
            if(item.isSys==1){
              if(item.type==1) {
                item.isSysText = "系统工具-app";
              }else if(item.type==3) {
                item.isSysText = "系统工具-公众号";
              }else{
                item.isSysText = "系统工具";
              }
            }else{
              item.isSysText = "自定义工具";
            }
            item.toolTypeText = item.toolType?this.dic.TOOL_TYPE[item.toolType]:"-"
          })
          this.tableData = res.data;
          this.$refs.phoneIndex.setData(this.tableData);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 拖拽后回调
    setList(list){
      this.search();
    },
    // 页面切换
    pageChange(i) {
      this.pageNo = i;
      this.getList();
    },
    // 切换启用状态
    switchChange(row){
      console.log(row)
      this.$http({
        url: "/buz/mcmMerchantModule/edit",
        type: "POST",
        data: {
          id:row.id,
          enable:row.enable,
          parentModuleCode:row.parentModuleCode,
        },
        apiPermissionCode:'systemSet_10_3'
      }).then((res)=>{
        this.getList();
      })
    },
    setPhoneComponent(){
      if(this.tab == "TOOLBAR"){
        return "phoneIndex"
      }else if(this.tab == "SELF_TOOLBAR"){
        return "phonePersonal"
      }else if(this.tab == "EXHIBITION_TOOLBAR"){
        return "phoneMarketing";
      }else if(this.tab == "CUSTOM_TOOLBAR"){
        return "phoneCustomer";
      }
    },
    getTableColumns(){
      const table = [
        {
          title: "模块",
          slot: "name",
          width: 200,
          align: "center"
        },
        
        {
          title: "类型",
          key: "isSysText",
          minWidth: 100,
          align: "center"
        },

        {
          title: "排序",
          key: "orderNum",
          minWidth: 60,
          align: "center"
        },
        {
          title: "是否启用",
          slot: "enable",
          minWidth: 100,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          minWidth: 80,
          align: "center"
        }
      ];
      if(this.tab == "SELF_TOOLBAR"){//个人中心
        table.splice(1,0,{
          title: "栏目",
          key: "toolTypeText",
          minWidth: 100,
          align: "center"
        })
      }else if(this.tab == "EXHIBITION_TOOLBAR"){//展业
        table.splice(1,0,{
          title: "显示文案",
          key: "description",
          minWidth: 100,
          align: "center"
        })
      }
      return table
    }
  },
};
</script>
<style lang='scss' scoped>
@import "./moduleConfig.scss";
</style>